import React from 'react'

const Location = props => (
  <svg width='1em' height='1em' viewBox='-1 -1 15 18' {...props}>
    <path d='M6.444 0C2.885 0 0 2.92 0 6.52c0 4.288 4.19 6.34 4.715 6.819.536.487.979 1.581 1.158 2.201a.61.61 0 0 0 .571.46.61.61 0 0 0 .572-.46c.179-.62.622-1.713 1.158-2.201.525-.478 4.715-2.53 4.715-6.819 0-3.6-2.885-6.52-6.445-6.52zm0 8.298c-.97 0-1.757-.796-1.757-1.778s.787-1.778 1.757-1.778c.971 0 1.758.796 1.758 1.778s-.787 1.778-1.758 1.778z' />
  </svg>
)

export default Location
